import { Icon, MinimalIconProps } from '@ardoq/icons';
import { ButtonType } from '@ardoq/button';
import {
  DropdownButtonOptionType,
  DropdownSize,
} from '@ardoq/dropdown-menu-ui';
import { ButtonWithDropdown } from '@ardoq/dropdown-menu';
import { Editor } from '@tiptap/core';
import { space } from '@ardoq/design-tokens';
import { ShortcutKeyCaption } from './ShortcutKey';

export type ToolbarDropdownOption = {
  /* Extension name */
  name: string;
  icon?: MinimalIconProps;
  buttonType?: DropdownButtonOptionType;
  label: string;
  isActive?: (editor: Editor) => boolean;
  onClick: (editor: Editor) => any;
  shortcut?: string[];
};

type ToolbarDropdownProps = {
  isDisabled?: boolean;
  icon: MinimalIconProps;
  options: ToolbarDropdownOption[];
  tooltipText: string;
  hideChevron?: boolean;
  editor: Editor;
  isActive?: boolean;
};

export const ToolbarDropdown = ({
  isDisabled,
  editor,
  icon,
  tooltipText,
  hideChevron,
  options,
  isActive,
}: ToolbarDropdownProps) => {
  const oneIsActive = options.some(option =>
    option.isActive ? option.isActive(editor) : false
  );
  const resolvedOptions = options.map(option => {
    const optionIsActive = option.isActive ? option.isActive(editor) : false;

    return {
      label: option.label,
      onClick: () => option.onClick(editor),
      leftIcon: option.icon,
      isActive: !oneIsActive ? undefined : optionIsActive,
      rightContent: option.shortcut ? (
        <ShortcutKeyCaption keys={option.shortcut} />
      ) : undefined,
    };
  });

  return (
    <ButtonWithDropdown
      tooltipText={tooltipText}
      data-tooltip-text={isDisabled ? undefined : tooltipText}
      isDisabled={isDisabled}
      buttonType={ButtonType.GHOST}
      isActive={isActive}
      dropdownSize={DropdownSize.AUTO}
      options={resolvedOptions}
      hideChevron={hideChevron}
      aria-label={tooltipText}
    >
      {hideChevron ? (
        <Icon iconName={icon.name} color={icon.color} />
      ) : (
        <Icon
          iconName={icon.name}
          color={icon.color}
          style={{ marginRight: `-${space.xsmall}` }}
        />
      )}
    </ButtonWithDropdown>
  );
};
